import React, { Component, Fragment } from "react";
import { Modal, ModalHeader, Button, ModalFooter } from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL_partidas_curso } from "../../../constants";

import { getAuthHeaders } from "../../../utils/auth";
class ConfirmPartidaCursoRemovalModal extends Component {
  state = {
    modal: false,
    isDeleting: false,
  };

  toggle = () => {
    this.setState(previous => ({
      modal: !previous.modal
    }));
  };

  deletePartida = (pk) => {
    const headers = getAuthHeaders();
    this.setState({ isDeleting: true });
    axios
      .delete(`${API_URL_partidas_curso}${pk}/`, { headers })
      .then(() => {
        this.setState({ isDeleting: false });
        this.props.resetState();
        this.toggle();
      })
      .catch((err) => {
        this.setState({ isDeleting: false });
        console.error("Error deleting partida de estudiantes:", err);
        toast.error(
          `No se pudo borrar la partida: ${err.response?.data?.detail || err.message || "error desconocido"}`
        );
      });
  };

  render() {
    return (
      <Fragment>
        <Button color="danger" onClick={() => this.toggle()}>
          Remover
        </Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>
            ¿Seguro que deseas borrar la partida de Estudiantes?
          </ModalHeader>

          <ModalFooter>
            <Button type="button" onClick={() => this.toggle()} disabled={this.state.isDeleting}>
              Cancelar
            </Button>
            <Button
              type="button"
              color="danger"
              onClick={() => this.deletePartida(this.props.pk)}
              disabled={this.state.isDeleting}
            >
              {this.state.isDeleting ? "Borrando..." : "Sí, borrar"}
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

export default ConfirmPartidaCursoRemovalModal;
